import { render } from "./NewPredictionUpload.vue?vue&type=template&id=eba7ee8e&ts=true"
import script from "./NewPredictionUpload.vue?vue&type=script&lang=ts"
export * from "./NewPredictionUpload.vue?vue&type=script&lang=ts"

import "./NewPredictionUpload.vue?vue&type=style&index=0&id=eba7ee8e&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__